/**
 * Created by mgoria on 5/26/2015
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DI = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bottlejs = require('bottlejs');

var _bottlejs2 = _interopRequireDefault(_bottlejs);

var _MissingServiceException = require('./Exception/MissingServiceException');

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Deep dependency injection module
 */
let DI = exports.DI = function () {
  function DI() {
    _classCallCheck(this, DI);

    this._bottle = new _bottlejs2.default();
    this._localBackend = false;
  }

  /**
   * Registers a service to container
   *
   * @param {String} serviceName
   * @param {Object} serviceClass
   * @param {String[]} dependencies
   */


  _createClass(DI, [{
    key: 'register',
    value: function register(serviceName, serviceClass, dependencies) {
      var args = [serviceName, serviceClass];

      if (dependencies) {
        args = args.concat(dependencies);
      }

      this._bottle.service.apply(this._bottle, args);
    }

    /**
     * Defines a factory method to create a service
     *
     * @param {String} serviceName
     * @param {Object} factoryClass
     */

  }, {
    key: 'factory',
    value: function factory(serviceName, factoryClass) {
      this._bottle.factory(serviceName, factoryClass);
    }

    /**
     * Adds a parameter into container
     *
     * @param {String} name
     * @param {*} value
     */

  }, {
    key: 'addParameter',
    value: function addParameter(name, value) {
      this._bottle.value(name, value);
    }

    /**
     * Adds an instantiated service into container
     *
     * @param {String} name
     * @param {Object} value
     */

  }, {
    key: 'addService',
    value: function addService(name, value) {
      if (!(value instanceof Object)) {
        throw new _deepCore2.default.Exception.InvalidArgumentException(value, 'Object');
      }

      this._bottle.value(name, value);
    }

    /**
     * Returns a service / parameter from container
     * @param {String} key
     * @returns {Object}
     */

  }, {
    key: 'get',
    value: function get(key) {
      if (typeof this._bottle.container[key] === 'undefined') {
        throw new _MissingServiceException.MissingServiceException(`Unregistered service or parameter "${key}"`);
      }

      return this._bottle.container[key];
    }

    /**
     * Checks if service / parameter exists in container
     * @param {String} key
     * @returns {Boolean}
     */

  }, {
    key: 'has',
    value: function has(key) {
      return this._bottle.container.hasOwnProperty(key);
    }

    /**
     * @param {Boolean} localBackend
     */

  }, {
    key: 'cleanup',
    value: function cleanup() {}
  }, {
    key: 'localBackend',
    set: function set(localBackend) {
      this._localBackend = localBackend;
    }

    /**
     * @returns {Boolean}
     */
    ,
    get: function get() {
      return this._localBackend;
    }
  }]);

  return DI;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-di/lib.compiled/DI.js
// module id = 376
// module chunks = 0